export default {
	numero_cte: '00001',
	cidade: 'Belo Horizonte',
	empresa: 'JM',
	frete: '500,00',
	notas: [
		{
			acao: 'atualizar',
			ar_nota: '190207122223000170001247559',
			cnpj_destinatario: '05937634000199',
			cnpj_dist: '07122223000170',
			cnpj_transp: '15292743000150',
			end_dest: 'AV JORGE VIEIRA, 19',
			nome_destinatario: 'DROG RAGONETE E SILVA LTDA ME',
			nome_dist: 'MEDICAMENTOS EIRELI',
			numero_nota: '001247559',
			pos_entrega: '0',
			qtd_volumes: '1',
			serie_nota: '001',
			valor_mercadoria: '894.53'
		},
		{
			acao: 'atualizar',
			ar_nota: '190207122223000170001247559',
			cnpj_destinatario: '05937634000199',
			cnpj_dist: '07122223000170',
			cnpj_transp: '15292743000150',
			end_dest: 'AV JORGE VIEIRA, 19',
			nome_destinatario: 'DROG RAGONETE E SILVA LTDA ME',
			nome_dist: 'FARMIX DIST. DE MEDICAMENTOS EIRELI',
			numero_nota: '001247559',
			pos_entrega: '0',
			qtd_volumes: '1',
			serie_nota: '001',
			valor_mercadoria: '744.53'
		},
		{
			acao: 'atualizar',
			ar_nota: '190205651966000617000297950',
			cnpj_destinatario: '08698543003666',
			cnpj_dist: '05651966000617',
			cnpj_transp: '15292743000150',
			end_dest: 'AVENIDA DOUTOR AMERICO LUZ, 94',
			nome_destinatario: 'NATUS FARMA COM DE MEDIC LTDA   LOJA 49',
			nome_dist: 'D. CENTER DISTRIBUIDORA LTDA',
			numero_nota: '000297950',
			pos_entrega: '17',
			qtd_volumes: '2',
			serie_nota: '012',
			valor_mercadoria: '290.01'
		},
		{
			acao: 'atualizar',
			ar_nota: '190205651966000617000298477',
			cnpj_destinatario: '03137344000305',
			cnpj_dist: '05651966000617',
			cnpj_transp: '15292743000150',
			end_dest: 'AV DR AMERICO LUZ, 260 LJ 02, 260',
			nome_destinatario: 'TR DROG LTDA',
			nome_dist: 'D. CENTER DISTRIBUIDORA LTDA',
			numero_nota: '000298477',
			pos_entrega: '23',
			qtd_volumes: '1',
			serie_nota: '012',
			valor_mercadoria: '381.49'
		},
		{
			acao: 'atualizar',
			ar_nota: '190205651966000617000297603',
			cnpj_destinatario: '03137344000305',
			cnpj_dist: '05651966000617',
			cnpj_transp: '15292743000150',
			end_dest: 'AV DR AMERICO LUZ, 260 LJ 02, 260',
			nome_destinatario: 'TR DROG LTDA',
			nome_dist: 'D. CENTER DISTRIBUIDORA LTDA',
			numero_nota: '000297603',
			pos_entrega: '25',
			qtd_volumes: '2',
			serie_nota: '012',
			valor_mercadoria: '613.08'
		},
		{
			acao: 'atualizar',
			ar_nota: '190211920636000178000619626',
			cnpj_destinatario: '05372930000190',
			cnpj_dist: '11920636000178',
			cnpj_transp: '15292743000150',
			end_dest: 'RUA DICK PRADO, 45',
			nome_destinatario: 'DOUGLAS DA SILVA PEDROSA',
			nome_dist: 'DIVINOPOLIS COM DE MEDICAMENTOS LTDA',
			numero_nota: '000619626',
			pos_entrega: '43',
			qtd_volumes: '2',
			serie_nota: '001',
			valor_mercadoria: '296.82'
		}
	]
};
